"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_STAGES = exports.ALL_AWS_REGIONS = exports.ALL_BRANDS = exports.RTL_LANGUAGES = void 0;
const basic_types_1 = require("./generated/basic-types");
exports.RTL_LANGUAGES = ['ar'];
exports.ALL_BRANDS = Object.values(basic_types_1.Brand);
exports.ALL_AWS_REGIONS = Object.values(basic_types_1.AwsRegion);
exports.ALL_STAGES = [basic_types_1.Stage.None, basic_types_1.Stage.Dev, basic_types_1.Stage.Staging, basic_types_1.Stage.Qa, basic_types_1.Stage.Prod];
